import CoreUtils from '../utils/CoreUtils';

import DataModel from '../model/DataModel';

export default class PropertyPageDataModel extends DataModel {
  constructor(session, modificationStateUpdated) {
    super();
    this.guid = crypto.randomUUID();
    this.session = session;
    this.modificationStateUpdated = modificationStateUpdated;
  }

  notifyModificationStateUpdated(modificationState) {
    if (CoreUtils.isDefinedAndNotNull(this.modificationStateUpdated))
      this.modificationStateUpdated(this, modificationState)
  }

  getModificationState() {
    return {
      isModified: false,
      hasErrors: false
    };
  }

  submitChanges(operationCompleteHandler) {
    operationCompleteHandler({
      successes: 0,
      failures: 0
    });
  }

  revertChanges() { }
}